export default {
  setLeadData ({ commit }, data) {
    commit('SET_DATA_SEARCH', data)
  }
}
